
function Header() {
    /// <summary>
    /// This object provides js functions for the Widget.Master.Header.js. <br/>
    /// It contains click handlers for the menu items, some with adjustments and the filling of the admin panel. 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.11.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 6.2.2019                                                *<br />
    /// **********************************************************************<br />
    /// * - added profile sub menu                                           *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 1.3.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Home.vb
    this.day = "";

}

Header.prototype = new vcTemplate();


Header.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler and fixes the width of the caption div. 
    /// </summary>
    var me = this;
   

    try {
        if (me.error) {
            return false;
        }

        //call the super class init function - so we can use the editDialog
        if (!me._initEditDialog && $.common && $.common.VisualBaseFunctions && $.common.VisualBaseFunctions.prototype) {
            me._initEditDialog = $.common.VisualBaseFunctions.prototype._initEditDialog;
            me.getPopupSize = $.common.VisualBaseFunctions.prototype.getPopupSize;
        }
       
        me.visualPopup = "";
        me.showInfo("", "", false);
        //add the click handler for the profile sub menu



        me.visual.find("#btn-sub-menu").off("click").on("click", function () {
            if ($(this).hasClass("open")) {
                $(this).removeClass("open");
                $("#div-profile-menu-popup").html("").hide();
            } else {
                var pos = $(this).offset();
                $(this).removeClass("open").addClass("open");
                $("#div-profile-menu-popup").show();
               
                $("#div-profile-menu-popup").HeaderSubMenu({ invokeType: "addVisualContent", parameter: { position: pos, btnHeight: parseInt($(this).height()), btnWidth: parseInt($(this).width()) } });

            }
        });

        //add the click handler for the username - opens the activity input dialog
        me.visual.find("#info-username").off("click").on("click", function () {

            if (!$(this).hasClass("cursor-active")) {
                return; // cursor-active only added for domain admins - activities shall only be opened then
            }

            // init dialog if not yet done
            if (!me.editDialog) {
                me._initEditDialog(0.95, 0.95, "");
                me.editDialog.html(me.vcC.getLoadingIcon());
            }

            me.editDialog.dialog("option", { width: me.editDialog.width, height: me.editDialog.height });

            if (me.myDiv) { me.myDiv.removeClass("reload").html($("<div>").attr("id", "div-dialog-activities").width(me.editDialog.width - 60).height(me.editDialog.height - 100)); }

            $("#div-dialog-activities").Activities({ invokeType: "addVisualBase", parameter: { Editable: true, ShowOverview: true, StartWithOverview: true, isSeen: false, BillingMode: false } });

            me.editDialog.dialog("open");
        });


        //add the click handler for the menus
        me.visual.find("#mainMenu .item,#userMenu .item").not(".lang-icon, #btn-sub-menu").off("click").on("click", function () {  me.loadContent($(this)); });
        
        //init the back button for the main master menu 
        $("#divBtnMasterBack").html(me.resources.backToMenu).button().off("click").on("click", function () {me.loadContent(me.visual.find(".group .item.selected"));});

        me.visual.find("#mainMenu .item,#userMenu .item").each(function () {
            if (me.mid === parseInt($(this).attr("data-mid"), 10)) {
                $(this).addClass("selected");
            }
        });

        //add the admin panel 
        if (me.mobile === false) {
            me.getSystemStatus();
        }


        me.setInfoStatus();


    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


Header.prototype.loadContent = function (obj) {
    /// <summary>
    /// This function handles the click handler events of the menu entries. 
    /// </summary>
    var me = this;
    var visualname;
    var mid;
    var signalparameter = "";
    var found = false;
    try {
        if (me.error) { return false; }
        if (obj.length === 0) { return false}

        visualname = obj.attr("data-visual");
        mid = parseInt(obj.attr("data-mid"), 10);

        if (typeof (visualname) === "undefined") { return false; }
        if (isNaN (mid)) { return false; }

        //take the selected class from everyone
        me.visual.find(".group .item").removeClass("selected");

        me.visual.find("#mainMenu .item,#userMenu .item").each(function () {
            if (me.mid === parseInt($(this).attr("data-mid"), 10)) {
                $(this).addClass("selected");
            }
        });

        //if no menu id but the visual name was found - open the visual and add it to the home 
        if (mid === -1) {
            switch (visualname) {
                case "VISUAL_MASTER_MENU":
                    found = true; break;
                case "VISUAL_MASTER_LOGGERLIST":
                    found = true; break;
                case "VISUAL_FAVORITES":
                    found = true; break;
                case "VISUAL2_PROJECTCENTER":
                    found = true; break;
            }
            if (found) {
                //hide the popup if we want to close the same visual
                //otherwise open the new visual
                if ($("#mainMasterMenu").is(":visible") && me.visualPopup === visualname) {
                    $("#mainMasterMenu").hide();
                    $("#main").show();
                    obj.removeClass("selected");

                    me.visual.find(".group .item").each(function () {
                        if (me.mid === parseInt($(this).attr("data-mid"), 10)) {
                            $(this).addClass("selected");
                        }
                    });
                } else {

                    me.visual.find(".group .item").removeClass("selected");
                    obj.addClass("selected");
                    $("#mainMasterMenuContent").html(me.vcC.getLoadingIcon());
                    
                    if (visualname !== "VISUAL2_PROJECTCENTER") {

                        me.vcVisual.addVisualByName("main", visualname, 'MasterMenuContent', getCurrentTimestamp(), parseInt($("#mainMasterMenuContent").height(), 10), parseInt($("#divHeaderMenu").width(), 10), "", signalparameter, me.deviceType,
                            function () {

                                $("#mainMasterMenu").show();
                                $("#mainMasterMenuContent").height(0).css("margin", 0);
                                $("#main").hide();
                                // 
                            });
                    } else {

                        //have to set the specific height to the content div
                        var bh = parseInt(_iBrowserHeight) -  parseInt($("#header").height() + $("#divMasterBack").height() + 120);
                        $("#mainMasterMenu").show();
                        $("#main").hide();
                        $("#mainMasterMenuContent").height(bh).css("margin", 20).ProjectCenter({ invokeType: "addVisualBase"});
                    }

                }
               me.visualPopup = visualname;
            }
        } else {
            window.location = visualname + "?mid=" + mid;
        }

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false}
}


Header.prototype.setInfoStatus = function () {
    /// <summary>
    /// This function gets the admin panel state values and sets them.<br/>
    /// At the end it centers the admin panel.
    /// </summary>
    var me = this;
    try {

        if (me.error) {return false;}

        setTimeout(function () {

       
        var item = me.visual.find("[data-visual='VISUAL2_PROJECTCENTER'] .name");
       
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, '2',
            function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result === '') {
                    me.showMessage(me.resources.err_loadData,true);
                    return false;
                }
                var state = JSON.parse(result);
                var html = "";
                var titles = "";
                if (state.OpenTickets > -1) { titles += me.resources.tickets;html += state.OpenTickets;}
              
                if (state.OpenAlarms > -1) {
                    if (html.length > 0) { titles += "/";html += "/";}
                    titles += me.resources.alarms;
                    html += state.OpenAlarms;
                }
                if (state.OpenActivities > -1) {
                    if (html.length > 0) { titles += "/";html += "/";}
                    titles += me.resources.activities;
                    html += state.OpenActivities;
                }
                if (html.length == 0) { html = me.resources.info; }
                item.html(html);
                item.attr("title", titles);
            });


        }, 3000);


        return true;
    } catch (ex) {
        me.writeError('getAdminPanel', ex);
        return false;
    }
};


Header.prototype.getSystemStatus = function () {
    /// <summary>
    /// This function gets the admin panel state values and sets them.<br/>
    /// At the end it centers the admin panel.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        setTimeout(function () {

      
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, '1',
            function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result === '') {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                var state = JSON.parse(result);

                //set health status for all user
                if (me.visual.find("#adminPanel").length > 0) { me.setHealthState(state.SystemHealthStatus); }
                //add the admin panel 
                if (me.visual.find("#adminPanel").length > 0) {me.getAdminPanel(state); }
                return true;
            });

        }, 2000);

        return true;
    } catch (ex) {
        me.writeError('getAdminPanel', ex);
        return false;
    }
};


Header.prototype.getAdminPanel = function (state) {
    /// <summary>
    /// This function gets the admin panel state values and sets them.<br/>
    /// At the end it centers the admin panel.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.setState(me.visual.find("#divAPArchiveErrors"), state.ArchiveError);
        me.setState(me.visual.find("#divAPDirtyUnitConfig"), state.DirtyUnitConfig);
        me.setState(me.visual.find("#divAPDeadUnit"), state.DeadUnit);

        me.setState(me.visual.find("#divAPAnalogBuffer"), state.AnalogBuffer);
        me.setState(me.visual.find("#divAPAnalogBufferRules"), state.AnalogBufferRules);
        me.setState(me.visual.find("#divAPAnalogInDirtyValid"), state.AnalogInDirtyValid);
        me.setState(me.visual.find("#divAPAnalogInValid"), state.AnalogInValid);

        me.setState(me.visual.find("#divAPOpenAlarms"), state.OpenAlarms);
        me.setState(me.visual.find("#divAPUnhandledAlarms"), state.UnhandledAlarms);
        me.setState(me.visual.find("#divAPWebError"), state.WebError);

        me.setState(me.visual.find("#divAPUserOnline"), state.UserOnline);
        /*me.setState(me.visual.find("#divAPPlayerOnline"), state.PlayerOnline);*/

        me.setState(me.visual.find("#divAPDBCon"), state.DBCon);
        me.setState(me.visual.find("#divAPDBOpen"), state.DBOpen);
        //center the admin panel
        me.centerAdminPanel();
        //show the panel
        me.visual.find("#adminPanel").fadeIn();
        return true;
    } catch (ex) {
        me.writeError('getAdminPanel', ex);
        return false;
    }
};


Header.prototype.setState = function (obj, state) {
    /// <summary>
    /// This function sets one single state value of the admin panel<br/>
    /// If the value is out of the limit it adds an error css class
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        obj.html(state.Value);

        if (state.Value > 10000) { obj.addClass("minor") }
        if (state.Status == -1) { obj.addClass("nostatus") }
        if (state.Status == 1) { obj.addClass("warn") }
        if (state.Status == 2) { obj.addClass("err") }
        return true;
    } catch (ex) {
        me.writeError('setState', ex);
        return false;
    }
};


Header.prototype.setHealthState = function (state) {
    /// <summary>
    /// This function sets an overall system health state information for all users
    /// </summary>
    var me = this;
    var limit;
    try {
        if (me.error) { return false; }


        //console.info(state);




        var obj = me.visual.find("#divAPSystemHealthStatus");
      
        //state.Value = 1;
        if (state.Value > -999) {
            if (state.Status == -1) {
                obj.addClass("icon-color-ok").html("<i class='fa-regular fa-exclamation-triangle' ></i> System status monitor not running!").show();
                return true;
            }
            if (state.Value == 0) { obj.hide(); }
            if (state.Value == 1) { obj.addClass("icon-color-warning").html("<i class='fa-regular fa-exclamation-triangle' ></i> Overall system WARNING state!").show(); }
            if (state.Value == 2) { obj.addClass("icon-color-error").html("<i class='fa-regular fa-exclamation-triangle' ></i> Overall system ERROR state!").show(); }
        } else {
            obj.hide();
        }
        return true;
    } catch (ex) {
        me.writeError('setState', ex);
        return false;
    }
};


Header.prototype.centerAdminPanel = function () {
    /// <summary>
    /// This function calculates the remaining width and centers the admin panel<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        var width = me.visual.find("#divHeaderMenu").width();
        var logo = parseInt(me.visual.find("#logo").width(),10);
        var user = parseInt(me.visual.find("#userMenu").width(),10);
        var main = parseInt(me.visual.find("#mainMenu").width(),10);
        var panel = parseInt(me.visual.find("#adminPanel").width(),10);
        width = parseInt((width - logo - main - user - panel) / 2, 10);
        me.visual.find("#adminPanel").css("margin-left", width);

        return true;
    } catch (ex) {
        me.writeError('centerAdminPanel', ex);
        return false;
    }
};


Header.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.group').hide();
            $('#divContent').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

